import { thresholdValue } from './const';

export class FloatingPoint {
  private static threshold = thresholdValue;
  private constructor() {}

  /** `a`, `b` 相等 */
  public static equal(a: number, b: number, threshold = this.threshold): boolean {
    return Math.abs(a - b) < threshold;
  }

  /** `a` 大于 `b` */
  public static greaterThan(a: number, b: number, threshold = this.threshold): boolean {
    return a - b > threshold;
  }

  /** `a` 大于等于 `b` */
  public static greaterThanOrEqual(a: number, b: number, threshold = this.threshold): boolean {
    return a - b > -threshold;
  }

  /** `a` 小于 `b` */
  public static lessThan(a: number, b: number, threshold = this.threshold): boolean {
    return b - a > threshold;
  }
  /** `a` 小于等于 `b` */
  public static lessThanOrEqual(a: number, b: number, threshold = this.threshold): boolean {
    return b - a > -threshold;
  }

  /** 是否在某个范围（包含最大最小值） */
  public static between(value: number, lower: number, upper: number, threshold = this.threshold) {
    return this.greaterThanOrEqual(value, lower, threshold) && this.lessThanOrEqual(value, upper, threshold);
  }
}
